module.exports = __webpack_public_path__ + "img/image 11.8cce1c8a.png";